import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ReportsPage from '../pages/reports/ReportsPage';
import UsersPage from '../pages/users/UsersPage';
import ToolsPage from '../pages/tools/ToolsPage';
import ToolPromptsPage from '../pages/tool-prompts/ToolPromptsPage';
import OrganisationsPage from '../pages/organisations/OrganisationsPage';
import TransactionsPage from '../pages/transactions/TransactionsPage';
import TemplatesPage from '../pages/templates/TemplatesPage';
import UserTemplatesPage from '../pages/user-templates/UserTemplatesPage';
import VocabularyPage from '../pages/vocabulary/VocabularyPage';
import ModelsPage from '../pages/models/ModelsPage';
import NotificationPage from '../pages/notification/NotificationPage';
import ErrorLogsPage from '../pages/error-logs/ErrorLogsPage';
import TokensLogsPage from '../pages/tokens-logs/TokensLogsPage';

const AppRoutes = () => (
  <Routes>
    <Route path="/reports" element={<ReportsPage />} />
    <Route path="/tools" element={<ToolsPage />} />
    <Route path="/tool-prompts" element={<ToolPromptsPage />} />
    <Route path="/users" element={<UsersPage />} />
    <Route path="/organisations" element={<OrganisationsPage />} />
    <Route path="/transactions" element={<TransactionsPage />} />
    <Route path="/templates" element={<TemplatesPage />} />
    <Route path="/user-templates" element={<UserTemplatesPage />} />
    <Route path="/vocabulary" element={<VocabularyPage />} />
    <Route path="/models" element={<ModelsPage />} />
    <Route path="/notification" element={<NotificationPage />} />
    <Route path="/error-logs" element={<ErrorLogsPage />} />
    <Route path="/tokens-logs" element={<TokensLogsPage />} />
    <Route path="/" element={<Navigate to="/reports" replace />} />
    <Route path="*" element={<Navigate to="/reports" replace />} />
  </Routes>
);

export default AppRoutes;
